import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import PaginationBar from './components/PaginationBar';
import TableContainer from './components/TableContainer';
import DataTable from './components/DataTable';
import ResponsiveShadow from './components/ResponsiveShadow';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import ConfirmModal from './components/modals/ConfirmModal';
import TipoBemModal from './components/modals/TipoBemModal';
import usePagination10 from './components/hooks/usePagination10';
import useReferenceData from './components/hooks/useReferenceData';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import Toolbar from './components/Toolbar';
import LoadingModal from './components/modals/LoadingModal';

const emptyForm = { idNatureza: '', id: '', descricao: '' };

function TiposBens() {
  const token = localStorage.getItem('token');
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [atualizar, setAtualizar] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState('');

  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const { setPagination } = usePagination10(items.length);
  const { naturezas } = useReferenceData(token, null);
  const filteredItems = search ? items.filter(i => i.descricao.toLowerCase().includes(search.toLowerCase())) : items;
  const displayed = filteredItems.slice(setPagination.startIndex, setPagination.startIndex + setPagination.rowsPerPage);

  useEffect(() => {
    setIsLoading(true);
    axios.get(`${API_BASE_URL.TIPO_BEM}/all`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        const sorted = [...r.data].sort((a, b) =>
          String(a.idNatureza).localeCompare(String(b.idNatureza)) || a.id - b.id
        );
        setItems(sorted);
      })
      .catch(() => showDefaultModal('error', 'Erro ao carregar tipos de bens.'))
      .finally(() => setIsLoading(false));
  }, [token, atualizar]);

  function handleChange(e) { const { name, value } = e.target; setForm(f => ({ ...f, [name]: value })); }
  function handleNew() { setForm(emptyForm); setShowModal(true); }
  function handleEdit() { if (selected.length !== 1) return; setForm({ ...selected[0] }); setShowModal(true); }

  function handleSave(e) {
    e.preventDefault();
    axios.post(`${API_BASE_URL.TIPO_BEM}/save`, form, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        setShowModal(false);
        setAtualizar(a => !a);
        setSelected([]); // Limpa seleção após salvar
      })
      .catch(() => showDefaultModal('error', 'Erro ao salvar tipo de bem.'));
  }

  function handleDelete() {
    if (selected.length === 0) return;
    showConfirmModal('delete', () => Promise.all(selected.map(s => axios.delete(`${API_BASE_URL.TIPO_BEM}/delete`, {
      params: { idNatureza: s.idNatureza, id: s.id }, headers: { Authorization: `Bearer ${token}` }
    }))).then(() => { setSelected([]); setAtualizar(a => !a); })
      .catch(() => showDefaultModal('error', 'Erro ao excluir tipo de bem.'))
    );
  }

  function toggleSelect(item) {
    const key = `${item.idNatureza}_${item.id}`;
    setSelected(prev => prev.find(s => `${s.idNatureza}_${s.id}` === key) ? [] : [item]);
  }

  const grouped = (naturezas || [])
    .filter(n => displayed.some(item => String(item.idNatureza) === String(n.id)))
    .map(n => ({
      natureza: n,
      tipos: displayed.filter(item => String(item.idNatureza) === String(n.id)),
    }));

  return (
    <Layout>
      <LoadingModal show={isLoading} />
      <ResponsiveShadow>
        <PageHeader title="TIPOS DE BENS" icon="bi-box" />
        <PageContent>
          <Toolbar onNew={handleNew} onEdit={handleEdit} disableEdit={selected.length !== 1} onDelete={handleDelete} disableDelete={selected.length === 0}>
            <div className="input-group input-group-sm toolbar-search">
              <span className="input-group-text bg-light"><i className="bi bi-search"></i></span>
              <input
                type="text"
                className="form-control"
                style={{ textTransform: 'uppercase', fontVariant: 'normal' }}
                placeholder="buscar por descrição..."
                value={search}
                onChange={e => setSearch(e.target.value.toUpperCase())}
              />
            </div>

          </Toolbar>
          <TableContainer isLoading={false}>
                              <DataTable head={<tr>
                  <th style={{ width: '3rem' }}>#</th><th>Descrição</th>
                </tr>}>
                <tbody>
                  {grouped.map(group => (
                    <React.Fragment key={`nat_${group.natureza.id}`}>
                      <tr style={{ backgroundColor: '#d1e7dd', pointerEvents: 'none' }}>
                        <td colSpan={2} className="fw-semibold small">
                          <i className="bi bi-tag me-2 text-success"></i>
                          {group.natureza.descricao}
                        </td>
                      </tr>
                      {group.tipos.map((item, idx) => (
                        <tr key={`${item.idNatureza}_${item.id}`}
                          className={selected.find(s => `${s.idNatureza}_${s.id}` === `${item.idNatureza}_${item.id}`) ? 'table-success' : ''}
                          onClick={() => toggleSelect(item)} style={{ cursor: 'pointer' }}>
                          <td className="text-muted" style={{ paddingLeft: '2rem' }}>{idx + 1}</td>
                          <td>{item.descricao}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </DataTable>
          </TableContainer>
        </PageContent>
        <PaginationBar setPagination={setPagination} />
      </ResponsiveShadow>
      <TipoBemModal show={showModal} onClose={() => setShowModal(false)} onSubmit={handleSave} form={form} handleChange={handleChange} naturezas={naturezas} />
      <DefaultModal {...setDefaultModal} />
      <ConfirmModal {...setConfirmModal} />
    </Layout>
  );
}

export default TiposBens;
